import type { FC } from "react";

import {
  CARD_IMAGE_DEFAULTS,
  type TCardImageProps,
} from "@/ui/components/data-display/Card/Card.config";
import { AspectRatio, Image } from "@/ui/components/primitives";
import { CardTags } from "./CardTags";

export const CardImage: FC<TCardImageProps> = (
  {
    image,
    ratio: ratio = CARD_IMAGE_DEFAULTS.ratio,
    tags,
    tagVariant,
  },
) => (
  <AspectRatio ratio={ratio} data-component="CardImage">
    <Image {...image} />
    <CardTags tags={tags} variant={tagVariant} />
  </AspectRatio>
);

CardImage.displayName = "CardImage";
